import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';

import { ServerErrorReferenceService } from '@services/server-error-reference/server-error-reference.service';

const FIRST_SERVER_ERROR_STATUS = 500;
const REQUEST_ID_HEADER = 'x-request-id';

function extractRequestId(error: HttpErrorResponse): string | null {
  const bodyRequestId: unknown = (error.error as { requestId?: unknown } | null)?.requestId;
  if (typeof bodyRequestId === 'string' && bodyRequestId.length > 0) {
    return bodyRequestId;
  }
  return error.headers?.get(REQUEST_ID_HEADER) ?? null;
}

export const serverErrorReferenceInterceptor: HttpInterceptorFn = (req, next) => {
  const serverErrorReferenceService = inject(ServerErrorReferenceService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status >= FIRST_SERVER_ERROR_STATUS) {
        const requestId = extractRequestId(error);
        if (requestId) {
          serverErrorReferenceService.registerServerErrorReference(requestId);
        }
      }
      return throwError(() => error);
    }),
  );
};
